module.exports = __webpack_public_path__ + "img/bq-se.3f241dbd.svg";